module.exports = __webpack_public_path__ + "static/img/wolves-1026.ffa10b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/old/wolves-1026.jpg
// module id = 5OXt
// module chunks = 1